<ng-container *ngIf="isModal">
    <kt-base-modal [title]="'Assign ' + masterBusinessLabel.Location " [showBody]="true" [description]="description"> 
        <div modal-body>
            <ng-template *ngTemplateOutlet="assignLocation"></ng-template>
        </div>
    </kt-base-modal>
</ng-container>

<div *ngIf="!isModal">
    <ng-template *ngTemplateOutlet="assignLocation"></ng-template>
</div>

<ng-template #assignLocation>
    <kt-loader [showLoader]="loading()">
        <form class="kt-form__section {{isModal ? 'kt-form__section-modal' : ''}}" (ngSubmit)="saveAssignLocation()">
            <div class="kt-heading kt-heading--md kt-heading--space-sm">
                <ng-container *ngIf="!isModal">
                    {{ 'Assign '+ masterBusinessLabel.Location  | translate}}
                </ng-container>
                <button
                    *ngxPermissionsOnly="PermissionV2.PEOPLE_GENERAL_DETAILS_MANAGE"
                    type="button" class="btn btn-brand btn-sm pull-right" (click)="addAssignLocation()">
                    {{'BUTTON.ADD' | translate}}
                </button>
            </div>

            <!-- Body start -->
            <div class="table-responsive kt-wizard-v2__form">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="min-width: 150px;">{{ masterBusinessLabel.Client | translate}}</th>
                            <th style="min-width: 150px;">{{masterBusinessLabel.Location | translate}}</th>
                            <th>
                                &nbsp;
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of getAssignLocationFormArray().controls;let i = index">
                            <td width="50%">
                                <kt-select [field]="formConstants.client" (valueChange)="clientChange($event, i)"
                                    [form]="getAssignLocation(i)" [options]="lookupOptions.client[i]" [values]="">
                                </kt-select>
                            </td>
                            <td width="50%">
                                <kt-select [field]="formConstants.location" [form]="getAssignLocation(i)"
                                    [options]="lookupOptions.locations[item.get('client').value]" [values]="''" [maxVisible]="3">
                                </kt-select>
                            </td>
                            <td width="60px" class="text-end">
                                <ng-container
                                    *ngxPermissionsOnly="PermissionV2.PEOPLE_GENERAL_DETAILS_MANAGE">
                                    <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm"
                                        (click)="removeAssignLocation(i)">
                                        <svg-icon class="svg_icon17x17" aria-label="My icon" src="assets/media/iq-svg/without_circle/icon_set_3/delete.svg"></svg-icon>
                                    </button>
                                </ng-container>

                            </td>
                        </tr>
                    </tbody>

                </table>

                <ng-container *ngIf="!getAssignLocationFormArray()?.length && !loading()">
                    <kt-no-record-found [noRecordFound]="noRecordFound"></kt-no-record-found>
                </ng-container>
            </div>
            <!-- Body end -->

            <!-- Footer start -->
            <div class="modal-footer"
                *ngxPermissionsOnly="PermissionV2.PEOPLE_GENERAL_DETAILS_MANAGE">
                <kt-button [buttonConfig]="buttonConstants">
                </kt-button>
            </div>
            <!-- Footer end -->
        </form>
    </kt-loader>
</ng-template>
